import { getApolloInstance } from "apollo/client"
import { GetServerSideProps } from "next"
import { OnboardingModalProvider } from "components/Modals/OnboardingModal/hook"
import Hire from "page-components/hire"
import { PARTNERSHIP_TIERS_QUERY } from "page-components/hire/gql"
import { PalletContextProvider } from "utils/hooks/usePalletContext"
import { buildRedirectToTeamPage } from "utils/redirects"
import { getPalletContext, PalletContext } from "utils/router"
import { PartnershipTiersQuery } from "__generated__/PartnershipTiersQuery"

export const getServerSideProps: GetServerSideProps = async context => {
    const apolloClient = getApolloInstance({ request: context.req })
    const palletContext = await getPalletContext(context.req)
    const slug = palletContext.pallet

    const { data: partnershipTierData } =
        await apolloClient.query<PartnershipTiersQuery>({
            query: PARTNERSHIP_TIERS_QUERY,
            variables: { pallet: slug },
        })
    if (
        partnershipTierData.applylist?.partnership &&
        !partnershipTierData.applylist.partnership.canRepurchase
    ) {
        const teamRedirect = await buildRedirectToTeamPage(
            apolloClient,
            context,
            palletContext,
            "/communities"
        )
        if (teamRedirect) return teamRedirect
    }

    if (partnershipTierData.applylist?.customHireLink) {
        return {
            redirect: {
                destination: partnershipTierData.applylist.customHireLink,
                permanent: false,
            },
        }
    }

    const referrer = context.req.headers.referer?.includes("/jobs")
        ? "jobs"
        : "talent"

    return {
        props: {
            palletContext: palletContext,
            initialApolloState: apolloClient.cache.extract(),
            referrer: referrer,
        },
    }
}

const HirePage = ({
    palletContext,
    referrer,
}: {
    palletContext: PalletContext
    referrer: "jobs" | "talent"
}) => {
    return (
        <PalletContextProvider value={palletContext}>
            <OnboardingModalProvider>
                <Hire referrer={referrer} />
            </OnboardingModalProvider>
        </PalletContextProvider>
    )
}

export default HirePage
